// Code 128 barcodes as SVG - the symbology Odoo 16 prints product labels in
// when a barcode isn't a valid EAN-13 (e.g. the 12-digit 300020138066).
// All-digit codes of even length use set C (two digits per symbol, the
// shortest); anything else uses set B. No dependency needed.

// Bar/space widths for symbol values 0-106 (106 = stop, 7 elements).
const PATTERNS = [
  '212222', '222122', '222221', '121223', '121322', '131222', '122213', '122312', '132212', '221213',
  '221312', '231212', '112232', '122132', '122231', '113222', '123122', '123221', '223211', '221132',
  '221231', '213212', '223112', '312131', '311222', '321122', '321221', '312212', '322112', '322211',
  '212123', '212321', '232121', '111323', '131123', '131321', '112313', '132113', '132311', '211313',
  '231113', '231311', '112133', '112331', '132131', '113123', '113321', '133121', '313121', '211331',
  '231131', '213113', '213311', '213131', '311123', '311321', '331121', '312113', '312311', '332111',
  '314111', '221411', '431111', '111224', '111422', '121124', '121421', '141122', '141221', '112214',
  '112412', '122114', '122411', '142112', '142211', '241211', '221114', '413111', '241112', '134111',
  '111242', '121142', '121241', '114212', '124112', '124211', '411212', '421112', '421211', '212141',
  '214121', '412121', '111143', '111341', '131141', '114113', '114311', '411113', '411311', '113141',
  '114131', '311141', '411131', '211412', '211214', '211232', '2331112',
];
const START_B = 104;
const START_C = 105;
const STOP = 106;

// The symbol values for `text`, start and checksum included.
export function code128Values(text: string): number[] {
  const useC = /^\d+$/.test(text) && text.length >= 2 && text.length % 2 === 0;
  const values: number[] = [useC ? START_C : START_B];
  if (useC) {
    for (let i = 0; i < text.length; i += 2) values.push(Number(text.slice(i, i + 2)));
  } else {
    for (const ch of text) {
      const code = ch.charCodeAt(0);
      if (code < 32 || code > 126) throw new Error(`Can't encode "${ch}" in a barcode`);
      values.push(code - 32);
    }
  }
  const checksum = values.reduce((sum, v, i) => sum + v * (i === 0 ? 1 : i), 0) % 103;
  values.push(checksum, STOP);
  return values;
}

// "1" = bar module, "0" = space module, quiet zones not included.
export function code128Modules(text: string): string {
  let out = '';
  for (const value of code128Values(text)) {
    PATTERNS[value].split('').forEach((w, i) => (out += (i % 2 === 0 ? '1' : '0').repeat(Number(w))));
  }
  return out;
}

// An SVG of the bars only, scaled to fill its box (the label sets the size).
export function code128Svg(text: string): string {
  const modules = code128Modules(text);
  const quiet = 10;
  const width = modules.length + quiet * 2;
  let rects = '';
  for (let i = 0; i < modules.length; ) {
    if (modules[i] === '1') {
      let run = 1;
      while (modules[i + run] === '1') run++;
      rects += `<rect x="${i + quiet}" y="0" width="${run}" height="100"/>`;
      i += run;
    } else i++;
  }
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${width} 100" preserveAspectRatio="none" shape-rendering="crispEdges" fill="#000">${rects}</svg>`;
}
